import type { DefaultOptionType } from 'antd/es/select';
import type { EquipmentTypesResponse } from './api';

export const normalizeEquipmentTypes = (list: EquipmentTypesResponse): DefaultOptionType[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.description,
    value: row.trailerKey,
  }));
};
